export var E_OPTION_MENU = {
    LOGOUT: 'LOGOUT',
};
export var IDENTIFIER_HEADER = 'header';
export var IDENTIFIER_HEADER_MENU_ITEM = 'header-menu-item';
export var E_HEADER_MENU_ITEM = {
    PROFILE: 'profile',
    CASES: 'case',
    USERS: 'users',
};
export var buildIdentifierHeaderMenuItem = function (name) { return "".concat(IDENTIFIER_HEADER_MENU_ITEM, "-").concat(name); };
